// extracted by mini-css-extract-plugin
module.exports = {"resetButtonContainer":"FilterTermsAndCondition_resetButtonContainer_2Ky6R"};